import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/france-departments.geojson";

const REGIONS = [
    { code: "Ain", name: "Ain" },
    { code: "Aisne", name: "Aisne" },
    { code: "Allier", name: "Allier" },
    { code: "Alpes-de-Haute-Provence", name: "Alpes-de-Haute-Provence" },
    { code: "Alpes-Maritimes", name: "Alpes-Maritimes" },
    { code: "Ardennes", name: "Ardennes" },
    { code: "Ardèche", name: "Ardèche" },
    { code: "Ariège", name: "Ariège" },
    { code: "Aube", name: "Aube" },
    { code: "Aude", name: "Aude" },
    { code: "Aveyron", name: "Aveyron" },
    { code: "Bas-Rhin", name: "Bas-Rhin" },
    { code: "Bouches-du-Rhône", name: "Bouches-du-Rhône" },
    { code: "Calvados", name: "Calvados" },
    { code: "Cantal", name: "Cantal" },
    { code: "Charente", name: "Charente" },
    { code: "Charente-Maritime", name: "Charente-Maritime" },
    { code: "Cher", name: "Cher" },
    { code: "Corrèze", name: "Corrèze" },
    { code: "Corse-du-Sud", name: "Corse-du-Sud" },
    { code: "Creuse", name: "Creuse" },
    { code: "Côte-d'Or", name: "Côte-d'Or" },
    { code: "Côtes-d'Armor", name: "Côtes-d'Armor" },
    { code: "Deux-Sèvres", name: "Deux-Sèvres" },
    { code: "Dordogne", name: "Dordogne" },
    { code: "Doubs", name: "Doubs" },
    { code: "Drôme", name: "Drôme" },
    { code: "Essonne", name: "Essonne" },
    { code: "Eure", name: "Eure" },
    { code: "Eure-et-Loir", name: "Eure-et-Loir" },
    { code: "Finistère", name: "Finistère" },
    { code: "Gard", name: "Gard" },
    { code: "Gers", name: "Gers" },
    { code: "Gironde", name: "Gironde" },
    { code: "Haut-Rhin", name: "Haut-Rhin" },
    { code: "Haute-Corse", name: "Haute-Corse" },
    { code: "Haute-Garonne", name: "Haute-Garonne" },
    { code: "Haute-Loire", name: "Haute-Loire" },
    { code: "Haute-Marne", name: "Haute-Marne" },
    { code: "Haute-Savoie", name: "Haute-Savoie" },
    { code: "Haute-Saône", name: "Haute-Saône" },
    { code: "Haute-Vienne", name: "Haute-Vienne" },
    { code: "Hautes-Alpes", name: "Hautes-Alpes" },
    { code: "Hautes-Pyrénées", name: "Hautes-Pyrénées" },
    { code: "Hauts-de-Seine", name: "Hauts-de-Seine" },
    { code: "Hérault", name: "Hérault" },
    { code: "Ille-et-Vilaine", name: "Ille-et-Vilaine" },
    { code: "Indre", name: "Indre" },
    { code: "Indre-et-Loire", name: "Indre-et-Loire" },
    { code: "Isère", name: "Isère" },
    { code: "Jura", name: "Jura" },
    { code: "Landes", name: "Landes" },
    { code: "Loir-et-Cher", name: "Loir-et-Cher" },
    { code: "Loire", name: "Loire" },
    { code: "Loire-Atlantique", name: "Loire-Atlantique" },
    { code: "Loiret", name: "Loiret" },
    { code: "Lot", name: "Lot" },
    { code: "Lot-et-Garonne", name: "Lot-et-Garonne" },
    { code: "Lozère", name: "Lozère" },
    { code: "Maine-et-Loire", name: "Maine-et-Loire" },
    { code: "Manche", name: "Manche" },
    { code: "Marne", name: "Marne" },
    { code: "Mayenne", name: "Mayenne" },
    { code: "Meurthe-et-Moselle", name: "Meurthe-et-Moselle" },
    { code: "Meuse", name: "Meuse" },
    { code: "Morbihan", name: "Morbihan" },
    { code: "Moselle", name: "Moselle" },
    { code: "Nièvre", name: "Nièvre" },
    { code: "Nord", name: "Nord" },
    { code: "Oise", name: "Oise" },
    { code: "Orne", name: "Orne" },
    { code: "Paris", name: "Paris" },
    { code: "Pas-de-Calais", name: "Pas-de-Calais" },
    { code: "Puy-de-Dôme", name: "Puy-de-Dôme" },
    { code: "Pyrénées-Atlantiques", name: "Pyrénées-Atlantiques" },
    { code: "Pyrénées-Orientales", name: "Pyrénées-Orientales" },
    { code: "Rhone", name: "Rhone" },
    { code: "Sarthe", name: "Sarthe" },
    { code: "Savoie", name: "Savoie" },
    { code: "Saône-et-Loire", name: "Saône-et-Loire" },
    { code: "Seine-et-Marne", name: "Seine-et-Marne" },
    { code: "Seine-Maritime", name: "Seine-Maritime" },
    { code: "Seine-Saint-Denis", name: "Seine-Saint-Denis" },
    { code: "Somme", name: "Somme" },
    { code: "Tarn", name: "Tarn" },
    { code: "Tarn-et-Garonne", name: "Tarn-et-Garonne" },
    { code: "Territoire de Belfort", name: "Territoire de Belfort" },
    { code: "Val-d'Oise", name: "Val-d'Oise" },
    { code: "Val-de-Marne", name: "Val-de-Marne" },
    { code: "Var", name: "Var" },
    { code: "Vaucluse", name: "Vaucluse" },
    { code: "Vendée", name: "Vendée" },
    { code: "Vienne", name: "Vienne" },
    { code: "Vosges", name: "Vosges" },
    { code: "Yonne", name: "Yonne" },
    { code: "Yvelines", name: "Yvelines" },
];

const REGION_CODES = REGIONS.map(r => r.code);

const FranceMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 2200, center: [2.5, 46.5] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="france"
            analyticsLocationType="france"
            trackingLabel="France Map"
            storageKey="france_map"
            title="🇫🇷 France Travel Map"
            subtitle="Click on French départements you've visited. Or use the checklist below!"
            items={REGIONS.map(r => ({ id: r.code, name: r.name }))}
            noun="Départements"
            unitLabel="départements"
            captionUnit="French départements"
            share={{
                region: 'France',
                fileName: 'visited-france-map.png',
                trackId: 'france'
            }}
            renderMap={renderMap}
        />
    );
};

export default FranceMapSection;
